import authenticationAxios from './authenticationAxios'

export const login = (login) => {
  return authenticationAxios.post(`/signin`, login,{withCredentials: true})
}

export const logout = (user) => {
  return authenticationAxios.post(`/signout`, user)
}

export const otp = (otp) => {
  authenticationAxios.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("token");
    if(token) {
      config.headers["Authorization"] = 'Bearer ' + token;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
  return authenticationAxios.post(`/otp`, otp)
}


export const resendOTPAPI = (resendOtp) => {

  authenticationAxios.interceptors.request.use(
      function(config) {
        const token = localStorage.getItem("token");
        if(token) {
          config.headers["Authorization"] = 'Bearer ' + token;
        }
        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
  );


  return authenticationAxios.post(`/resend/otp`, resendOtp)
}
